<template>
  <div class="flex flex-col space-y-10">
    <!-- BEGIN Compétences personnelles search bar -->
    <div id="compperso-searchbar">
      <competences-by-template-search-bar
        :templates="templateCompetencesPerso"
        :filter="filterCompetencesPerso"
        libelle="Rechercher une compétence personnelle"
        @selectCompetence="
          (value) => {
            selectCompetence(value, constants.COMPETENCES_FILTER_TYPES.perso);
          }
        "
        @selectTemplate="
          (template) => {
            selectTemplate(template, constants.COMPETENCES_FILTER_TYPES.perso);
          }
        "
      />
      <div
        v-if="filterCompetencesPerso.length > 0"
        class="flex flex-wrap space-y-3 gap-x-2 items-baseline mt-5"
      >
        <tag
          v-for="(competence, icomp) in filterCompetencesPerso"
          :key="'perso' + icomp"
          :libelle="getLibelleCompetencePerso(competence)"
          :is-closeable="true"
          :scale-on-hover="true"
          text-size="text-sm"
          theme-color="indigo"
          icon-size="h-3 w-3"
          @close="
            deleteCompetence(
              competence,
              constants.COMPETENCES_FILTER_TYPES.perso
            )
          "
        />
      </div>
      <div
        v-if="filterCompetencesPerso.length === 0"
        class="flex justify-center mt-5 font-normal text-base"
      >
        Aucune compétence personnelle n'est sélectionnée.
      </div>
    </div>
    <!-- END Compétences personnelles search bar -->

    <!-- BEGIN Compétences socio-professionnelles search bar -->
    <div id="compsocio-searchbar">
      <competences-by-template-search-bar
        :templates="templateCompetencesSocio"
        :filter="filterCompetencesSocio"
        libelle="Rechercher une compétence socio-professionnelle"
        @selectCompetence="
          (value) => {
            selectCompetence(value, constants.COMPETENCES_FILTER_TYPES.socio);
          }
        "
        @selectTemplate="
          (template) => {
            selectTemplate(template, constants.COMPETENCES_FILTER_TYPES.socio);
          }
        "
      />
      <div
        v-if="filterCompetencesSocio.length > 0"
        class="flex flex-wrap space-y-3 gap-x-2 items-baseline mt-5"
      >
        <tag
          v-for="(competence, icomp) in filterCompetencesSocio"
          :key="'socio' + icomp"
          :libelle="
            competence.template.data[0].filter(
              $filterEvaluationIntitulesMulti2
            )[0].criterions[competence['competence']].description
          "
          :is-closeable="true"
          :scale-on-hover="true"
          text-size="text-sm"
          theme-color="indigo"
          icon-size="h-3 w-3"
          @close="
            deleteCompetence(
              competence,
              constants.COMPETENCES_FILTER_TYPES.socio
            )
          "
          :can-truncate="true"
          class="max-w-1/5"
        />
      </div>
      <div
        v-if="filterCompetencesSocio.length === 0"
        class="flex justify-center mt-5 font-normal text-base"
      >
        Aucune compétence socio-professionnelles n'est sélectionnée.
      </div>
    </div>
    <!-- END Compétences socio-professionnelles search bar -->

    <!-- BEGIN Compétences professionnelles search bar -->
    <div id="comppro-searchbar">
      <competences-by-sheet-list
        :filter="filterCompetencesPro"
        @selectSheet="
          (values) => {
            selectSheet(values.sheet, values.isSelected);
          }
        "
        @selectActivity="
          (values) => {
            selectSheetActivity(
              values.sheet,
              values.numActivity,
              values.isSelected
            );
          }
        "
        @selectTypeCompetence="
          (values) => {
            selectSheetTypeCompetence(
              values.sheet,
              values.numActivity,
              values.typeCompetence,
              values.isSelected
            );
          }
        "
        @selectCompetence="
          (values) => {
            selectSheetCompetence(
              values.sheet,
              values.numActivity,
              values.typeCompetence,
              values.numCompetence,
              values.isSelected
            );
          }
        "
      />
    </div>
  </div>
</template>

<script>
import Tag from '../../../components/Tag.vue';
import CompetencesByTemplateSearchBar from './components/CompetencesByTemplateSearchBar.vue';
import CompetencesBySheetList from './components/CompetencesBySheetList.vue';
import Constants from '../../../constants';

export default {
  components: {
    CompetencesByTemplateSearchBar,
    CompetencesBySheetList,
    Tag,
  },
  props: {
    templates: Array,
    filter: Object,
  },

  data() {
    return {
      searchCompetencesPerso: '',
      isSuggestionsCompetencesPersoDisplayed: false,
      isSearchingCompetencesPerso: false,
      constants: Constants,
    };
  },

  methods: {
    getLibelleCompetencePerso(competence) {
      return competence.domaine === null
        ? competence.template.data[0][competence.competence].libelle
        : competence.template.data[0][competence.domaine][0].libelle ===
          competence.template.data[0][competence.domaine][competence.competence]
            .libelle
        ? competence.template.data[0][competence.domaine][competence.competence]
            .libelle
        : competence.template.data[0][competence.domaine][0].libelle +
          ' - ' +
          competence.template.data[0][competence.domaine][competence.competence]
            .libelle;
    },

    selectTemplate(template, type) {
      let filter = [...this.filter[type]];
      let totalCompByTemplate = 0;

      switch (template.type) {
        case 'multi1':
          template.data[0].forEach((competence, competenceIndex) => {
            if (
              competence.display_cartographie &&
              !filter.some(
                (c) =>
                  c.template.id === template.id &&
                  c.competence === parseInt(competenceIndex)
              )
            )
              filter.push({
                template: template,
                domaine: null,
                competence: parseInt(competenceIndex),
              });
          });
          break;
        case 'multi2':
          //delete all template competences in filter
          filter = filter.filter(
            (competence) => !(competence.template.id === template.id)
          );

          totalCompByTemplate = template.data[0].filter(
            this.$filterEvaluationIntitulesMulti2
          )[0].criterions.length;

          if (
            this.filter[type].filter(
              (competence) => competence.template.id === template.id
            ).length === totalCompByTemplate
          ) {
            this.updateFilter(filter, type);
            return;
          }

          template.data[0]
            .filter(this.$filterEvaluationIntitulesMulti2)[0]
            .criterions.forEach((competence, competenceIndex) => {
              filter.push({
                template: template,
                domaine: null,
                competence: parseInt(competenceIndex),
              });
            });
          break;
        case 'multi3':
          //delete all template competences in filter
          filter = filter.filter(
            (competence) => !(competence.template.id === template.id)
          );

          totalCompByTemplate = template.data[0].reduce(
            (acc, domaine) =>
              acc +
              (Array.isArray(domaine) //For historied template, there is one value in domain list which describe history informations
                ? domaine.filter(
                    (competence) => competence.display_cartographie
                  ).length
                : 0),
            0
          );

          if (
            this.filter[type].filter(
              (competence) => competence.template.id === template.id
            ).length === totalCompByTemplate
          ) {
            this.updateFilter(filter, type);
            return;
          }

          template.data[0].forEach((domaine, domaineIndex) => {
            if (!Array.isArray(domaine)) return; //For historied template, there is one value in domain list which describe history informations
            domaine.forEach((competence, competenceIndex) => {
              if (
                competence.display_cartographie &&
                !filter.some(
                  (c) =>
                    c.template.id === template.id &&
                    c.domaine === parseInt(domaineIndex) &&
                    c.competence === parseInt(competenceIndex)
                )
              )
                filter.push({
                  template: template,
                  domaine: parseInt(domaineIndex),
                  competence: parseInt(competenceIndex),
                });
            });
          });
          break;

        default:
          break;
      }
      this.updateFilter(filter, type);
    },

    selectCompetence(newCompetence, type) {
      if (
        this.filter[type].some(
          (competence) =>
            competence.template.id === newCompetence.template.id &&
            competence.domaine === newCompetence.domaine &&
            competence.competence === newCompetence.competence
        )
      ) {
        this.deleteCompetence(newCompetence, type);
        return;
      }

      let filter = [...this.filter[type]];
      filter.push(newCompetence);
      this.updateFilter(filter, type);
    },

    deleteCompetence(competenceToDelete, type) {
      let filter = [...this.filter[type]];
      filter = filter.filter(
        (competence) =>
          !(
            competence.template.id === competenceToDelete.template.id &&
            competence.domaine === competenceToDelete.domaine &&
            competence.competence === competenceToDelete.competence
          )
      );
      this.updateFilter(filter, type);
    },

    selectSheet(sheet, isSelected) {
      let filter = [...this.filter[Constants.COMPETENCES_FILTER_TYPES.pro]];

      filter = filter.filter((comp) => comp.sheet.id != sheet.id);

      //de-select sheet, so just delete all sheet competences
      if (!isSelected) {
        this.updateFilter(filter, Constants.COMPETENCES_FILTER_TYPES.pro);
        return;
      }

      sheet.data.activities.forEach((activity, activityIndex) => {
        activity.activity_tasks.forEach((task, taskIndex) => {
          filter.push({
            sheet: sheet,
            activity: parseInt(activityIndex),
            type: 'activity_tasks',
            competence: parseInt(taskIndex),
          });
        });
        activity.activity_pratiques_pros.forEach(
          (pratiquePro, pratiqueProIndex) => {
            filter.push({
              sheet: sheet,
              activity: parseInt(activityIndex),
              type: 'activity_pratiques_pros',
              competence: parseInt(pratiqueProIndex),
            });
          }
        );
        activity.activity_connaissances.forEach(
          (connaissance, connaissanceIndex) => {
            filter.push({
              sheet: sheet,
              activity: parseInt(activityIndex),
              type: 'activity_connaissances',
              competence: parseInt(connaissanceIndex),
            });
          }
        );
        activity.activity_comportements.forEach(
          (comportement, comportementIndex) => {
            filter.push({
              sheet: sheet,
              activity: parseInt(activityIndex),
              type: 'activity_comportements',
              competence: parseInt(comportementIndex),
            });
          }
        );
      });

      this.updateFilter(filter, Constants.COMPETENCES_FILTER_TYPES.pro);
    },

    selectSheetActivity(sheet, numActivity, isSelected) {
      let filter = [...this.filter[Constants.COMPETENCES_FILTER_TYPES.pro]];

      filter = filter.filter(
        (comp) => !(comp.sheet.id === sheet.id && comp.activity === numActivity)
      );

      //de-select sheet, so just delete all sheet competences
      if (!isSelected) {
        this.updateFilter(filter, Constants.COMPETENCES_FILTER_TYPES.pro);
        return;
      }

      sheet.data.activities[numActivity].activity_tasks.forEach(
        (task, taskIndex) => {
          filter.push({
            sheet: sheet,
            activity: parseInt(numActivity),
            type: 'activity_tasks',
            competence: parseInt(taskIndex),
          });
        }
      );
      sheet.data.activities[numActivity].activity_pratiques_pros.forEach(
        (pratiquePro, pratiqueProIndex) => {
          filter.push({
            sheet: sheet,
            activity: parseInt(numActivity),
            type: 'activity_pratiques_pros',
            competence: parseInt(pratiqueProIndex),
          });
        }
      );
      sheet.data.activities[numActivity].activity_connaissances.forEach(
        (connaissance, connaissanceIndex) => {
          filter.push({
            sheet: sheet,
            activity: parseInt(numActivity),
            type: 'activity_connaissances',
            competence: parseInt(connaissanceIndex),
          });
        }
      );
      sheet.data.activities[numActivity].activity_comportements.forEach(
        (comportement, comportementIndex) => {
          filter.push({
            sheet: sheet,
            activity: parseInt(numActivity),
            type: 'activity_comportements',
            competence: parseInt(comportementIndex),
          });
        }
      );

      this.updateFilter(filter, Constants.COMPETENCES_FILTER_TYPES.pro);
    },

    selectSheetTypeCompetence(sheet, numActivity, typeCompetence, isSelected) {
      let filter = [...this.filter[Constants.COMPETENCES_FILTER_TYPES.pro]];

      filter = filter.filter(
        (comp) =>
          !(
            comp.sheet.id === sheet.id &&
            comp.activity === numActivity &&
            comp.type === typeCompetence
          )
      );

      if (!isSelected) {
        this.updateFilter(filter, Constants.COMPETENCES_FILTER_TYPES.pro);
        return;
      }

      sheet.data.activities[numActivity][typeCompetence].forEach(
        (comp, compIndex) => {
          filter.push({
            sheet: sheet,
            activity: parseInt(numActivity),
            type: typeCompetence,
            competence: parseInt(compIndex),
          });
        }
      );

      this.updateFilter(filter, Constants.COMPETENCES_FILTER_TYPES.pro);
    },

    selectSheetCompetence(sheet, numActivity, typeCompetence, numCompetence) {
      if (
        this.filter[Constants.COMPETENCES_FILTER_TYPES.pro].some(
          (c) =>
            sheet.id == c.sheet.id &&
            numActivity == c.activity &&
            typeCompetence == c.type &&
            numCompetence == c.competence
        )
      ) {
        this.deleteSheetCompetence(
          sheet,
          numActivity,
          typeCompetence,
          numCompetence
        );
        return;
      }
      let filter = [...this.filter[Constants.COMPETENCES_FILTER_TYPES.pro]];
      filter.push({
        sheet: sheet,
        activity: parseInt(numActivity),
        type: typeCompetence,
        competence: parseInt(numCompetence),
      });

      this.updateFilter(filter, Constants.COMPETENCES_FILTER_TYPES.pro);
    },

    deleteSheetCompetence(sheet, numActivity, typeCompetence, numCompetence) {
      let filter = [...this.filter[Constants.COMPETENCES_FILTER_TYPES.pro]];
      filter = filter.filter(
        (competence) =>
          !(
            competence.sheet.id == sheet.id &&
            competence.activity == numActivity &&
            competence.type == typeCompetence &&
            competence.competence == numCompetence
          )
      );
      this.updateFilter(filter, Constants.COMPETENCES_FILTER_TYPES.pro);
    },

    updateFilter(filter, type) {
      switch (type) {
        case Constants.COMPETENCES_FILTER_TYPES.perso:
          this.$emit('updateCompetencesPersoFilter', filter);
          break;
        case Constants.COMPETENCES_FILTER_TYPES.socio:
          this.$emit('updateCompetencesSocioFilter', filter);
          break;
        case Constants.COMPETENCES_FILTER_TYPES.pro:
          this.$emit('updateCompetencesProFilter', filter);
          break;
        default:
          break;
      }
    },
  },

  computed: {
    templateCompetencesPerso() {
      return this.templates.filter(
        (t) =>
          t.page.module.name ===
          Constants.MODULE_NEOPASS_FORM_COMPETENCES_PERSONNELLES
      );
    },
    templateCompetencesSocio() {
      return this.templates.filter(
        (t) =>
          t.page.module.name ===
          Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO
      );
    },

    filterCompetencesPerso() {
      return this.filter[Constants.COMPETENCES_FILTER_TYPES.perso];
    },
    filterCompetencesSocio() {
      return this.filter[Constants.COMPETENCES_FILTER_TYPES.socio];
    },
    filterCompetencesPro() {
      return this.filter[Constants.COMPETENCES_FILTER_TYPES.pro];
    },
  },
};
</script>
